import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return path;
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Is this URL a video we host (looping <video>) vs a legacy instagram link?
export function isHostedVideo(url) {
  if (!url) return false;
  if (/instagram\.com/i.test(url)) return false;
  return /\/api\/files\//.test(url) || /\.(mp4|mov|webm|m4v)(\?|$)/i.test(url);
}

// Fetch AI-generated ingredient cover images (cached & reused across recipes).
export async function fetchIngredientImages(names) {
  return fetchObjectImages("/ingredients/images", names);
}

// Fetch AI-generated utensil cover images (cached & reused across recipes).
export async function fetchUtensilImages(names) {
  return fetchObjectImages("/utensils/images", names);
}

async function fetchObjectImages(endpoint, names) {
  const list = (names || []).map((n) => (n || "").trim()).filter(Boolean);
  if (!list.length) return {};
  try {
    const { data } = await api.post(endpoint, { names: list });
    return data.images || {};
  } catch {
    return {};
  }
}
export async function uploadVideo(file, onProgress) {
  const CHUNK = 4 * 1024 * 1024; // 4MB
  const { data: init } = await api.post("/uploads/video/init");
  const uploadId = init.upload_id;
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK, (i + 1) * CHUNK);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", i);
    fd.append("file", blob, `chunk-${i}`);
    await api.post("/uploads/video/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const fd = new FormData();
  fd.append("upload_id", uploadId);
  fd.append("filename", file.name || "reel.mp4");
  const { data } = await api.post("/uploads/video/complete", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.video_url;
}

